const reducer = (state = {}, action) => {
  switch (action.type) {
    case 'SET_NEWS':     
      return { ...state, news: action.json[0], loading: false }
    case 'SET_COURSESLIST':
      return { ...state, coursedata: action.json, loading: false }
    case 'SET_VALUELIST':
      return { ...state, valuedata: action.json, loading: false }
    case 'SET_EVENTS':
      return { ...state, eventdata: action.json, loading: false }
    case 'SET_USERGROUPS':
      return { ...state, groupdata: action.json, loading: false }
    case 'SET_SHAREDUSER':
      return { ...state, shareduserdata: action.json, loading: false }
    case 'SET_CREATEREFLECTION':
      return { ...state, reflectionAdd: action.json, loading: false }
    case 'SET_EDITREFLECTION':
      return { ...state, reflectionEdit: action.json, loading: false }
    case 'SET_REMOVEREFLECTION':
      return { ...state, removeRefData: action.json, loading: false }
    case 'SET_REMOVECOMMENT':
     return { ...state, removeCommentdata: action.json, loading: false }   
    case 'SET_REFLECTION':
      return { ...state, reflectiondata: action.json}
    case 'SET_CREATECOMMENT':
      return { ...state, commentdata: action.json}
    case 'SET_CREATELIKES':
      return { ...state, likedata: action.json}
    case 'SET_LIKES':
      return { ...state, ListdataList: action.json}
    case 'SET_COMMENT':
      return { ...state, commentListdata: action.json}
    case 'SET_SHAREDUSERS':
      return { ...state, sharedusersData: action.json}
    case 'SET_UPDATEPROFILE':
      return { ...state, profiledata: action.json}
    case 'SET_TEMPLATE':
      return { ...state, templateData: action.json}
    case 'SET_CREATE_SHOWCASE':
      return { ...state, createshowcasedata: action.json}
    case 'SET_SHOWCASE':
      return { ...state, showcasedata: action.json,loading: false}
    case 'SET_SWITCH_SHOWCASE':
      return { ...state, switchshowcase: action.json,loading: false}
    case 'SET_UPDATE_SHOWCASE':
      return { ...state, showcaseupdatedata: action.json}
    case 'SET_REMOVE_SHOWCASE':
      return { ...state, showcaseremovedata: action.json}
    case 'SET_SEARCH_REFLECTION':
      return { ...state, searchdata: action.json}
    case 'SET_CREATE_SHOWCASE_REFLECTION':  
      return { ...state, createshowcaserefdata: action.json}
    case 'SET_SHOWCASE_REFLECTION':
      return { ...state, reflectiondata: action.json}
    case 'SET_REMOVESHOWCASE_REFLECTION':
      return { ...state, removeshowcaserefdata: action.json}
    case 'SET_CREATE_PUBLIC_ACCESS':
      return { ...state, publicaccessdata: action.json}
    case 'SET_SORT_SHOWCASE_REFLECTION':
      return { ...state, sortdata: action.json}
    case 'SET_MAP_REFLECTION':
      return { ...state, mapreflectiondata: action.json}
    case 'SET_TEMPLATE_DETAILS':
     return { ...state, templateDetails: action.json}
    case 'SET_REMOVE_TEMPLATE':
     return { ...state, removeTemplate: action.json,loading: false }
    case 'SET_TASK':
      return { ...state, ListdataListtask: action.json,loading: false}  
    case 'SET_INBOX_RESPOND':
      return { ...state, sendRespond: action.json,loading: false }
    case 'SET_DISPLAY_RESPOND':
      return { ...state, displayRespond: action.json,loading: false } 
    case 'SET_DELETE_RESPOND':
      return { ...state, deleteInboxRespond: action.json,loading: false }
    case 'SET_PROFILE_DETAILS':
      return { ...state, selecteprofiledata: action.json,loading: false }
    case 'SET_TOTALUSERSLIST':
     return { ...state, totalUserlist: action.json,loading: false }
    case 'SET_USER_REFLECTION':
      return { ...state, userReflection: action.json,loading: false}  
    case 'SET_TEST_RESPOND':
      return { ...state, testRespond: action.json,loading: false}
    case 'SET_TEST_VISUALZATION':
     return { ...state, uservisualzation: action.json,loading: false}   
    case 'SET_PUBLIC_ACCESS':
     return { ...state, showcaseaccess: action.json,loading: false}
    case 'SET_ARTEFACTS_IMAGE':
     return { ...state, displayArtefacts: action.json,loading: false}
    case 'SET_GENERATE_PDF':
     return { ...state, pdfdata: action.json,loading: false}
    case 'SET_UPLOAD_FILE':
     return { ...state, uploadData: action.json,loading: false}
    case 'SET_PDF_REFLECTION':
      return { ...state, pdfreflection: action.json, loading: false}
    case 'SET_REFLECTION_SHARED':
      return { ...state, reflectiondataNotifcation: action.json, loading: false}
    case 'SET_DELETE_ATTACHMENTS':
      return { ...state, deleteattachement: action.json, loading: false}
    case 'SET_EDIT_REFLECTION_USER':
    return { ...state, reflectionUserEdit: action.json, loading: false}

    default:
      return state;
  }
};

export default reducer;
